import { useState } from "react";
import { rewardedAvailable, showRewarded, type RewardKind } from "../lib/ads.js";
import { useSession } from "../lib/auth.js";
import { ErrorText } from "./ui.js";

/** "Watch an ad to unlock" button. Disabled outside the native app where rewarded ads do not exist. */
export function RewardButton({ kind, label, onGranted }: { kind: RewardKind; label: string; onGranted: (until: string) => void }) {
  const { data } = useSession();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  if (!data) return null;
  if (!rewardedAvailable()) return <p className="muted">{label}はアプリ版でリワード広告を見ると利用できます。</p>;
  return (
    <div>
      <button
        className="btn primary"
        type="button"
        disabled={busy}
        onClick={async () => {
          setBusy(true);
          setError(null);
          try {
            const r = await showRewarded(data.user.id, kind);
            onGranted(r.until);
          } catch (e) {
            setError(e);
          } finally {
            setBusy(false);
          }
        }}
      >
        広告を見て{label}
      </button>
      <ErrorText error={error} />
    </div>
  );
}
